import { createSlice } from "@reduxjs/toolkit";

export const organizationStore = createSlice({
  name: "organization",
  initialState: {
    data: [],
    risksData: {},
    findingsData: {},
    improvementsData: {},
    auditsTasksData: {},
    auditsData: {},
    permits: {},
    linkedData: {
      linked_improvements: [],
      linked_auditTasks: [],
    },
  },
  reducers: {
    setOrganizationData: (state, action) => {
      state.data = {
        ...state.data,
        ...action.payload, // Spread the incoming data to update the state
      };

      // Directly replace risksData if available
      state.risksData = action.payload.risks || state.risksData;

      // Directly replace findingsData
      state.findingsData =
        action.payload.findings !== undefined
          ? action.payload.findings
          : state.findingsData;

      // Directly replace improvementsData
      state.improvementsData =
        action.payload.improvements !== undefined
          ? action.payload.improvements
          : state.improvementsData;

      // Directly replace auditsTasksData
      state.auditsTasksData =
        action.payload.audit_tasks !== undefined
          ? action.payload.audit_tasks
          : state.auditsTasksData;

      // Directly replace auditsData
      state.auditsData =
        action.payload.audits !== undefined
          ? action.payload.audits
          : state.auditsData;

      // Directly replace permits if available
      state.permits = action.payload.permits || state.permits;
    },
    setLinkedData: (state, action) => {
      state.linkedData = action.payload;
    },
  },
});

export const { setOrganizationData, setLinkedData } = organizationStore.actions;

export default organizationStore.reducer;
